import React from "react";
import { useNavigate } from "react-router-dom";

function LiveFluidDemoPage() {
  const navigate = useNavigate();

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/lives-show");
    }
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999999,
        overflowY: "auto",
        background:
          "radial-gradient(circle at top right, rgba(0,242,255,0.24), transparent 30%), radial-gradient(circle at bottom left, rgba(255,0,90,0.18), transparent 32%), #03070d",
        color: "#fff",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <style>
        {`
          @keyframes fadeUp {
            from { opacity: 0; transform: translateY(30px); }
            to { opacity: 1; transform: translateY(0); }
          }

          @keyframes signalPulse {
            0%, 100% { height: 24px; opacity: 0.55; }
            50% { height: 80px; opacity: 1; }
          }

          @keyframes scanLine {
            0% { transform: translateX(-100%); }
            100% { transform: translateX(100%); }
          }

          @keyframes speedBar {
            0% { width: 20%; }
            50% { width: 92%; }
            100% { width: 70%; }
          }

          @keyframes glowPulse {
            0%, 100% { box-shadow: 0 0 20px rgba(0,242,255,0.25); }
            50% { box-shadow: 0 0 55px rgba(0,242,255,0.75); }
          }

          .signal-bar {
            width: 18px;
            border-radius: 999px;
            background: linear-gradient(180deg, #00f2ff, #00b7ff);
            box-shadow: 0 0 18px rgba(0,242,255,0.65);
            animation: signalPulse 1.4s ease-in-out infinite;
          }

          .signal-bar.b2 { animation-delay: 0.15s; }
          .signal-bar.b3 { animation-delay: 0.3s; }
          .signal-bar.b4 { animation-delay: 0.45s; }
          .signal-bar.b5 { animation-delay: 0.6s; }

          .scan-line {
            position: absolute;
            top: 0;
            bottom: 0;
            width: 45%;
            background: linear-gradient(90deg, transparent, rgba(0,242,255,0.16), transparent);
            animation: scanLine 2.4s linear infinite;
          }

          .speed-fill {
            height: 100%;
            border-radius: 999px;
            background: linear-gradient(90deg, #00f2ff, #00b7ff);
            box-shadow: 0 0 18px rgba(0,242,255,0.6);
            animation: speedBar 2.2s ease-in-out infinite;
          }
        `}
      </style>

      <button
        onClick={goBack}
        style={{
          position: "fixed",
          top: 22,
          left: 22,
          zIndex: 10000000,
          padding: "11px 18px",
          borderRadius: 16,
          border: "1px solid rgba(0,242,255,0.45)",
          background: "rgba(0, 12, 20, 0.9)",
          color: "#00f2ff",
          fontWeight: 900,
          cursor: "pointer",
          boxShadow: "0 0 18px rgba(0,242,255,0.25)",
        }}
      >
        ← Retour
      </button>

      <div
        style={{
          minHeight: "100vh",
          padding: "80px 18px 50px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        <h1
          style={{
            fontSize: 42,
            margin: "0 0 12px",
            fontWeight: 900,
            textShadow: "0 0 22px rgba(0,242,255,0.75)",
            animation: "fadeUp 0.7s ease forwards",
          }}
        >
          ⚡ Expérience fluide
        </h1>

        <p
          style={{
            maxWidth: 760,
            color: "#9befff",
            fontSize: 18,
            lineHeight: 1.6,
            marginBottom: 34,
            animation: "fadeUp 0.9s ease forwards",
          }}
        >
          Simulation d’un live stable avec latence faible, signal réseau actif
          et lecture mobile fluide.
        </p>

        <div
          style={{
            width: "100%",
            maxWidth: 760,
            borderRadius: 34,
            background:
              "linear-gradient(180deg, rgba(8,22,34,0.95), rgba(2,6,12,0.98))",
            border: "1px solid rgba(0,242,255,0.35)",
            boxShadow: "0 0 45px rgba(0,242,255,0.22)",
            padding: 28,
            position: "relative",
            overflow: "hidden",
            animation: "fadeUp 1.1s ease forwards",
          }}
        >
          <div className="scan-line" />

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: 18,
              position: "relative",
              zIndex: 2,
            }}
          >
            <div
              style={{
                padding: 22,
                borderRadius: 24,
                background: "rgba(0,0,0,0.35)",
                border: "1px solid rgba(0,242,255,0.18)",
              }}
            >
              <h3 style={{ marginTop: 0, color: "#fff" }}>📶 Signal réseau</h3>

              <div
                style={{
                  height: 100,
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "center",
                  gap: 10,
                  marginTop: 20,
                }}
              >
                <div className="signal-bar" />
                <div className="signal-bar b2" />
                <div className="signal-bar b3" />
                <div className="signal-bar b4" />
                <div className="signal-bar b5" />
              </div>

              <p style={{ color: "#9befff", fontWeight: 900 }}>
                Connexion excellente
              </p>
            </div>

            <div
              style={{
                padding: 22,
                borderRadius: 24,
                background: "rgba(0,0,0,0.35)",
                border: "1px solid rgba(0,242,255,0.18)",
              }}
            >
              <h3 style={{ marginTop: 0, color: "#fff" }}>⚡ Latence live</h3>

              <div
                style={{
                  margin: "24px auto",
                  width: 145,
                  height: 145,
                  borderRadius: "50%",
                  border: "2px solid rgba(0,242,255,0.55)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  animation: "glowPulse 2s infinite",
                }}
              >
                <strong style={{ fontSize: 36, color: "#00f2ff" }}>0.6s</strong>
                <span style={{ color: "#9befff", fontSize: 13 }}>
                  ultra faible
                </span>
              </div>

              <p style={{ color: "#9befff", fontWeight: 900 }}>
                Streaming stable
              </p>
            </div>

            <div
              style={{
                padding: 22,
                borderRadius: 24,
                background: "rgba(0,0,0,0.35)",
                border: "1px solid rgba(0,242,255,0.18)",
              }}
            >
              <h3 style={{ marginTop: 0, color: "#fff" }}>🎬 Lecture vidéo</h3>

              <div
                style={{
                  marginTop: 28,
                  height: 18,
                  borderRadius: 999,
                  background: "rgba(255,255,255,0.08)",
                  border: "1px solid rgba(0,242,255,0.18)",
                  overflow: "hidden",
                }}
              >
                <div className="speed-fill" />
              </div>

              <div
                style={{
                  marginTop: 28,
                  fontSize: 34,
                  fontWeight: 900,
                  color: "#00f2ff",
                  textShadow: "0 0 18px rgba(0,242,255,0.55)",
                }}
              >
                60 FPS
              </div>

              <p style={{ color: "#9befff", fontWeight: 900 }}>
                Expérience mobile fluide
              </p>
            </div>
          </div>

          <div
            style={{
              marginTop: 24,
              padding: 18,
              borderRadius: 22,
              background: "rgba(0,242,255,0.08)",
              border: "1px solid rgba(0,242,255,0.18)",
              color: "#d9fbff",
              fontSize: 15,
              lineHeight: 1.6,
              position: "relative",
              zIndex: 2,
            }}
          >
            EVO-LIVE est pensé pour offrir une navigation rapide, une lecture
            claire et une expérience verticale moderne sur Android et iOS.
          </div>
        </div>
      </div>
    </div>
  );
}

export default LiveFluidDemoPage;
